(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('ModuleDetailController', ModuleDetailController);

    ModuleDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Module', 'Product'];

    function ModuleDetailController($scope, $rootScope, $stateParams, previousState, entity, Module, Product) {
        var vm = this;

        vm.module = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('uniromaLandingApp:moduleUpdate', function(event, result) {
            vm.module = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
